import React, {useContext, useState} from "react";
import {
    getIdUtenteLoggato,
    getValoreFormattato, TIPO_ELEMENTO_BTN_AGGIUNGI, TIPO_ELEMENTO_CHECK,
    TIPO_ELEMENTO_FORMULA,
    TIPO_ELEMENTO_LABEL, TIPO_ELEMENTO_LISTA, TIPO_ELEMENTO_LIVELLO, TIPO_ELEMENTO_NOTA, TIPO_ELEMENTO_SEPARATORE,
    TIPO_ELEMENTO_SOTTOLIVELLO,
    TIPO_ELEMENTO_VALORE
} from "../../../../utility/common";
import TabellaKpiConfView from "./TabellaKpiConfView";
import {aggiungiSottolivelloKpiApi} from "../../services/KpiServices";
import {TranslateContext} from "../../../../context/TranslateContext";

export default function TabellaKpiConfController({
                                                     tabella,
                                                     handlerChange,
                                                     idKpi
                                                 }) {

    const [showDettagli, setShowDettagli] = useState(false);
    const [elementoDettagli, setElementoDettagli] = useState();
    const [elementoSelezionato, setElementoSelezionato] = useState();
    const [show, setShow] = useState(false);
    const [showModalUpdEl, setShowModalUpdEl] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext);

    const token = localStorage.getItem('ns-access-token');
    const idUtenteLoggato = getIdUtenteLoggato(token);

    function getClasse(el) {
        let classe = '';

        if (parseInt(el.tipo) === TIPO_ELEMENTO_BTN_AGGIUNGI) {
            classe = 'sost-td-btn_aggiungi';
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_SOTTOLIVELLO) {
            classe = "sost-td-sottolivellolivello-kpi";
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_LABEL) {
            classe = "sost-td-label-kpi";
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_SEPARATORE) {
            classe = "sost-td-separatore-kpi";
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_FORMULA) {
            classe = 'sost-elemento-kpi-formula';
        }

        if (el.modificato && el.modificato === true) {
            classe += ' sost-elemento-modificato'
        }
        return classe;
    }

    function getValoreByTipo(el) {
        let valore = el.label || ' ';

        if (el.modificato === true) {
            valore = el.valore;
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_FORMULA
            || parseInt(el.tipo) === TIPO_ELEMENTO_VALORE
            || parseInt(el.tipo) === TIPO_ELEMENTO_NOTA) {
            valore = getValoreFormattato(el.valore, el.formatter);
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_LISTA) {
            valore = getValoreFormattato(el.valore, el.formatter);
        }

        // Se sono un ESRS senza topics_valori, non mostro il valore "1" caricato di default, ma mostro ""
        if (el.topics && el.topics.length > 0 && el.topics_valori && el.topics_valori.length === 0) {
            valore = '';
        }
        return valore;
    }

    function getValoreTopics(el) {
        let valore = '';
        if (el.topics.length > 0) {
            el.topics.map((item, index) => {
                valore = item.valore;
            })
        }
        return valore;
    }

    function getDescrTopics(el) {
        let descr = '';
        if (el.topics.length > 0) {
            el.topics.map((item, index) => {
                descr = item.descr;
            })
        }
        return descr;
    }

    function getClasseAllineamentoEl(el) {
        let classe = '';

        if (parseInt(el.tipo) === TIPO_ELEMENTO_FORMULA
            || parseInt(el.tipo) === TIPO_ELEMENTO_VALORE
            || parseInt(el.tipo) === TIPO_ELEMENTO_NOTA
            || parseInt(el.tipo) === TIPO_ELEMENTO_LISTA) {
            classe += ' text-center';
        }
        if (el.tipo != TIPO_ELEMENTO_LIVELLO
            && el.tipo != TIPO_ELEMENTO_SEPARATORE
            && el.tipo != TIPO_ELEMENTO_CHECK
            && el.tipo != TIPO_ELEMENTO_BTN_AGGIUNGI
            && !el.is_anno) {
            classe += ' ns-mouse-pointer';
        }
        return classe;
    }

    function getIconaDettaglio(elemento) {
        return (
            ((elemento.testo_dettaglio && elemento.testo_dettaglio !== '') || (elemento.titolo_dettaglio && elemento.titolo_dettaglio !== '')) &&
            <i
                className="fas fa-info-circle ns-mouse-pointer ps-2"
                style={{
                    fontSize: "1.2rem"
                }}
                onClick={() => {
                    setElementoDettagli(elemento);
                    setShowDettagli(true);
                }}
            />
        );
    }

    function onHideDialog() {
        if (!showDettagli) return;
        setShowDettagli(false);
    }

    async function aggiungiRiga(el, btnAggiungi = true) {
        let tabellaClone = JSON.parse(JSON.stringify(tabella));

        // Recupero il sottolivello precedente a quello attuale
        let sottolivello = null;

        for (let l = 0; l < tabellaClone.length; l++) {
            if (tabellaClone[l].ordine == el.index_livello) {
                for (let sl = 0; sl < tabellaClone[l].sottolivelli.length; sl++) {
                    if (btnAggiungi) {
                        let idxSubLev = el.index_sottolivello > 1 ? el.index_sottolivello - 1 : 1;
                        if (tabellaClone[l].sottolivelli[sl].ordine == idxSubLev) {
                            sottolivello = JSON.parse(JSON.stringify(tabellaClone[l].sottolivelli[sl]));
                            sottolivello.ordine = el.index_sottolivello;

                            tabellaClone[l].sottolivelli.splice(sl + 1, 0, sottolivello);
                            break
                        }
                    } else {
                        let idxSubLev = el.index_sottolivello;
                        if (tabellaClone[l].sottolivelli[sl].ordine == idxSubLev) {
                            sottolivello = JSON.parse(JSON.stringify(tabellaClone[l].sottolivelli[sl]));
                            sottolivello.ordine = el.index_sottolivello + 1;

                            tabellaClone[l].sottolivelli.splice(sl + 1, 0, sottolivello);
                            break
                        }
                    }
                }
            }
        }

        console.log('tabellaClone', tabella, tabellaClone)

        if (sottolivello) {
            let idxNewSubLev = btnAggiungi ? el.index_sottolivello : (el.index_sottolivello + 1)

            const response = await aggiungiSottolivelloKpiApi(idKpi, tabellaClone, el.index_livello, idxNewSubLev);
            if (response.data.result === 0) {
                handlerChange();
            } else {
                setModalMsg(response.data.description);
                setShow(true);
            }
        }
    }

    function showModalUpdateElemento(el) {
        if (el.tipo != TIPO_ELEMENTO_LIVELLO
            && el.tipo != TIPO_ELEMENTO_SEPARATORE
            && el.tipo != TIPO_ELEMENTO_CHECK
            && el.tipo != TIPO_ELEMENTO_BTN_AGGIUNGI
            && !el.is_anno) {
            setElementoSelezionato(el);
            setShowModalUpdEl(true);
        }
    }

    return (
        <TabellaKpiConfView
            elementoDettagli={elementoDettagli}
            tabella={tabella}
            getClasse={getClasse}
            getClasseAllineamentoEl={getClasseAllineamentoEl}
            getIconaDettaglio={getIconaDettaglio}
            getValoreByTipo={getValoreByTipo}
            handlerChange={handlerChange}
            showDettagli={showDettagli}
            onHideDialog={onHideDialog}
            getValoreTopics={getValoreTopics}
            getDescrTopics={getDescrTopics}
            idUtenteLoggato={idUtenteLoggato}
            aggiungiRiga={aggiungiRiga}
            showMsg={show}
            setShowMsg={setShow}
            modalMsg={modalMsg}
            showModalUpdateElemento={showModalUpdateElemento}
            showModalUpdEl={showModalUpdEl}
            elementoSelezionato={elementoSelezionato}
            hideModalUpdateElemento={() => {
                setShowModalUpdEl(false);
            }}
            handlerErrorUpdateElemento={() => {
                setModalMsg(translate("Si è verificato un errore. Riprova più tardi"));
                setShow(true);
            }}
        />
    );
}